/**
 * Created by akirilyuk on 2/9/18.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/createCaseSubViews/botView.tmpl"),
        Button = require("ui/button/Button"),
        AttachmentsView = require("connection-views/ticketTab/extendedList/TicketAttachmentView"),
        AttachmentUpload = require("connection-views/ticketTab/extendedList/AttachmentUploadInput"),
        BotView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        BotView = Marionette.ItemView.extend({
            template: template,
            className: 'create-case-sub-view-bot',

            ui: {
                logsAttachmentsRegion: ".logs-attachments-region .data-container",
                logsAttachmentsUpload: ".logs-attachments-region .attachments-upload",
                fwAttachmentsRegion: ".framework-attachments-region .data-container",
                fwAttachmentsUpload: ".framework-attachments-region .attachments-upload",
                codeAttachmentsRegion: ".code-attachments-region .data-container",
                codeAttachmentsUpload: ".code-attachments-region .attachments-upload"
            },
            // the buttons are only for PoC the solution design
            uiComponents: {
                logsAttachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.logsAttachmentsRegion",
                        collection: "view._getAttachmentsCollection",
                        type: "logs",
                        doFilter: true
                    }
                },
                logsAttachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.logsAttachmentsUpload",
                        view: "view",
                        collection: "view._getAttachmentsCollection",
                        type: "logs"
                    }
                },
                fwAttachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.fwAttachmentsRegion",
                        collection: "view._getAttachmentsCollection",
                        type: "fw",
                        doFilter: true
                    }
                },
                fwAttachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.fwAttachmentsUpload",
                        view: "view",
                        collection: "view._getAttachmentsCollection",
                        type: "fw"
                    }
                },
                codeAttachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.codeAttachmentsRegion",
                        collection: "view._getAttachmentsCollection",
                        type: "code",
                        doFilter: true
                    }
                },
                codeAttachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.codeAttachmentsUpload",
                        view: "view",
                        collection: "view._getAttachmentsCollection",
                        type: "code"
                    }
                }
            },

            initialize: function (options) {
                this.attachmentsCollection = options.attachmentsCollection;
                this._bindEvents();
            },

            _bindEvents: function () {
                // this.listenTo(this.contextModel,"change:extendedViewIsOpen",this._onExtendedViewStateChange);
            },

            _getAttachmentsCollection: function(){
                return this.attachmentsCollection;
            }

        });
    });
    return BotView;
});
